<script>
  import { onMount } from "svelte";
  import { Router, Route } from "svelte-routing";

  // Bileşenler
  import AdminNavbar from "components/Navbars/AdminNavbar.svelte";
  import Sidebar from "components/Sidebar/Sidebar.svelte";
  import HeaderStats from "components/Headers/HeaderStats.svelte";
  import FooterAdmin from "components/Footers/FooterAdmin.svelte";

  // Sayfalar
  import Dashboard from "views/admin/Dashboard.svelte";
  import Settings from "views/admin/Settings.svelte";
  import Permission from "views/admin/Permission.svelte";
  import Roles from "views/admin/Roles.svelte";
  import Gosterge from "views/admin/Gosterge.svelte";
  import Formul from "views/admin/Formul.svelte";
  import Deger from "views/admin/Deger.svelte";
  import Help from "views/admin/Help.svelte";
  import { checkAuthentication } from '../../config';

  export let location;
  export let admin ="";

  let isAuthenticated = false;

  onMount(async () => {
    isAuthenticated = await checkAuthentication();
    if (!isAuthenticated) {
      alert('Lütfen Giriş Yapıınız!');
      window.location.href = "/auth/login";
    }
  });
</script>

{#if isAuthenticated}
  <div >
    <Sidebar {location} />
    <div class="relative md:ml-64 bg-blueGray-100">
      <AdminNavbar />
      <HeaderStats />
      <div class="px-4 md:px-10 mx-auto w-full -m-24">
        <Router url="admin">
          <Route path="dashboard" component={Dashboard} />
          <Route path="settings" component={Settings} />
          <Route path="permission" component={Permission} />
          <Route path="roles" component={Roles} />
          <Route path="gosterge" component={Gosterge} />
          <Route path="formul" component={Formul} />
          <Route path="deger" component={Deger} />
          <Route path="help" component={Help} />
        </Router>
        <FooterAdmin />
      </div>
    </div>
  </div>
{/if}
